// costants
import { TABS } from "../../constants/index";

export interface MenuItemType {
  id: number;
  key: string;
  icon: string;
  tooltipTitle: string;
  className?: string;
  tabId:
    | TABS.BOOKMARK
    | TABS.CALLS
    | TABS.CHAT
    | TABS.CHAT_SUP
    | TABS.CONTACTS
    | TABS.SETTINGS
    | TABS.USERS
    | TABS.TEST
    | TABS.WORKPLACE
    | TABS.TASK
    ;
}
const MENU_ITEMS: MenuItemType[] = [
  // 20250602 No show profile menu here (just keep in context menu only)
  // {
  //   id: 1,
  //   key: "pills-user-tab",
  //   icon: "bx bx-user-circle",
  //   tooltipTitle: "Profile",
  //   className: "d-none d-md-block",
  //   tabId: TABS.USERS,
  // },
  {
    id: 2,
    key: "pills-chat-tab",
    // icon: "bx bx-conversation",
    icon: "	far fa-comment-alt",
    tooltipTitle: "Chats",
    tabId: TABS.CHAT,
  },


  {
    id: 3,
    key: "pills-chatsub-tab",
    icon: "fas fa-comment-dollar",
    tooltipTitle: "Chats",
    tabId: TABS.CHAT_SUP,
  },

  // {
  //   id: 4,
  //   key: "pills-calls-tab",
  //   icon: "bx bx-phone-call",
  //   tooltipTitle: "Calls",
  //   tabId: TABS.CALLS,
  // },
  // {
  //   id: 5,
  //   key: "pills-bookmark-tab",
  //   icon: "bx bx-bookmarks",
  //   tooltipTitle: "Bookmark",
  //   tabId: TABS.BOOKMARK,
  // },

  {
    id: 8,
    key: "pills-workplace-tab",
    // icon: "mdi mdi-earth",
    icon: "fas fa-globe",
    tooltipTitle: "Your focusing memo",
    tabId: TABS.WORKPLACE,
  },
  
  {
    id: 9,
    key: "pills-task",
    icon: "fas fa-tasks",
    tooltipTitle: "Task",
    tabId: TABS.TASK,
  },  

  {
    id: 6,
    key: "pills-setting-tab",
    // icon: "bx bx-cog",
    icon: "fa fa-gear",
    tooltipTitle: "Settings",
    tabId: TABS.SETTINGS,
  },

  {
    id: 7,
    key: "pills-test-tab",
    icon: "bx bx-bug",
    tooltipTitle: "Test",
    tabId: TABS.TEST,
  },  
];

export { MENU_ITEMS };
